import { AnyAri, ConfluenceSpaceAri, IdentityTeamAri, JiraProjectAri } from '@atlassian/ari';

import { logErrorMessage } from '../sentry';

export const getTeamId = (teamAri: string) => {
	let teamId: string | undefined;

	const isIdentityTeamsAri = IdentityTeamAri.check(teamAri);

	if (isIdentityTeamsAri) {
		const identityTeamId = IdentityTeamAri.parse(teamAri).teamId;
		if (identityTeamId !== 'unidentified') {
			teamId = identityTeamId;
		} else {
			logErrorMessage('Team ID has value "unidentified" in getTeamId', { teamAri });
		}
	} else {
		logErrorMessage('Cannot parse IdentityTeamARI in getTeamId', { teamAri });
	}

	return teamId;
};

export const getTeamProfileUrl = (containerAri: string, teamAri: string) => {
	let teamProfileUrl: string | undefined;
	const productPath = ConfluenceSpaceAri.check(containerAri)
		? 'wiki'
		: JiraProjectAri.check(containerAri)
			? 'jira'
			: undefined;

	let teamId: string | undefined;
	teamId = getTeamId(teamAri);
	if (productPath && teamId) {
		teamProfileUrl = `${window.location.origin}/${productPath}/people/team/${teamId}`;
	} else {
		logErrorMessage('Cannot create teamProfileUrl in getTeamProfileUrl', { containerAri, teamAri });
	}

	return teamProfileUrl;
};

export const getSiteId = (containerAri: string) => {
	const siteId = AnyAri.check(containerAri) && AnyAri.parse(containerAri).cloudId;

	if (!siteId) {
		logErrorMessage('Cannot parse containerAri in getSiteId', { containerAri });
		return;
	}

	return siteId;
};

export const getTeamAri = (teamId: string) => {
	try {
		return IdentityTeamAri.create({
			teamId,
		}).toString();
	} catch (error) {
		logErrorMessage('Cannot create IdentityTeamAri in getTeamAri', { teamId });
	}
};
